import { Text, VStack } from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';

export const PageNotFound: React.FC = () => {
  return (
    <VStack
      align="center"
      justify="center"
      bgColor="blue.900"
      h="100vh"
      color={'white'}
      fontFamily={FontFamily.NEUE_HAAS_DISPLAY_ROMAN}>
      <Image image="logo-white" width={200} />
      <Text fontSize={48}>404</Text>
      <Text fontSize={12} textTransform="uppercase" letterSpacing={2}>
        Page Not Found
      </Text>
    </VStack>
  );
};
